import { useEffect, type ReactNode } from 'react'
import { useLocation } from 'react-router'
import { useCurrentUser } from '@m3-tech/boss-core'

interface UserpilotTrackerProps {
    children: ReactNode
}

export function UserpilotTracker({ children }: UserpilotTrackerProps) {
    const location = useLocation()
    const user = useCurrentUser()

    useEffect(() => {
        if (!user?.id || !window.userpilot) return

        window.userpilot.identify(String(user.id), {
            fullName: [user.firstName, user.lastName].filter(Boolean).join(' '),
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            language: user.language,
            bossVersion: 'BOSS Modernization',
        })
    }, [user?.id, user?.firstName, user?.lastName, user?.email, user?.language])

    useEffect(() => {
        window.userpilot?.reload()
    }, [location.pathname])

    return <>{children}</>
}
